export const baseURLs: { [key: string]: string } = {
  core: process.env.VUE_APP_FUNCTION_URI
    ? process.env.VUE_APP_FUNCTION_URI
    : "http://localhost:8888/.netlify/functions/",
};
